import React, { Children } from 'react';
import PropTypes from 'prop-types';
import './switch-group.scss';

function SwitchGroup({
  className,
  children,
  name,
  onChange,
  defaultSelected,
  disabled,
}) {
  return (
    <div className={`switch-group ${className}`}>
      <label>
        <input
          type="checkbox"
          name={name}
          onChange={onChange}
          defaultChecked={defaultSelected}
          disabled={disabled}
        />
        {Children.map(children, (child) => child)}
      </label>
    </div>
  );
}

export default SwitchGroup;
SwitchGroup.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  defaultSelected: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
SwitchGroup.defaultProps = {
  name: '',
  onChange: () => {},
  defaultSelected: 0,
  className: '',
  disabled: false,
};
